import script from "./DropMenuComment.vue?vue&type=script&setup=true&lang=js"
export * from "./DropMenuComment.vue?vue&type=script&setup=true&lang=js"

import "./DropMenuComment.vue?vue&type=style&index=0&id=05d5710c&lang=scss"

const __exports__ = script;

export default __exports__